import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RenderBlocksModule } from 'render/render-blocks/render-blocks.module';
import { AltTextPipe } from 'render/render-shared/alt-text/alt-text.pipe';
import { RenderSharedModule } from 'render/render-shared/render-shared.module';
import { RenderProductColorsModule } from 'render/render-shared/ui/render-product-colors/render-product-colors.module';
import { RenderProductPricesModule } from 'render/render-shared/ui/render-product-prices/render-product-prices.module';
import { RenderProductPurchaseOptionsModule } from 'render/render-shared/ui/render-product-sizes/render-product-purchase-options.module';
import { LazyLoadModule } from 'shared/lazy-load/lazy-load.module';
import { SharedModule } from 'shared/shared.module';

import { PieceProductCarouselRenderComponent } from './piece-product-carousel-render.component';


export const pieceProductCarouselRenderModuleEntryComponents = [
  PieceProductCarouselRenderComponent
];

@NgModule({
  imports: [
    AltTextPipe,
    SharedModule,
    RenderSharedModule,
    RenderBlocksModule,
    LazyLoadModule,
    RenderProductPricesModule,
    RenderProductPurchaseOptionsModule,
    RenderProductColorsModule
  ],
  declarations: pieceProductCarouselRenderModuleEntryComponents,
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ]
})
export class PieceProductCarouselRenderModule {}

export default pieceProductCarouselRenderModuleEntryComponents;
